module.exports = __webpack_public_path__ + "img/ynweb_copy.35bc6f40.svg";